import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import TopDockLayout from "../Layouts/TopDockLayout/TopDockLayout";
// FieldAppShell migrated to modern stack — Wave 7 (features/field-app/).
// Legacy shell at src/Layouts/FieldAppShell/* kept under LEGACY header.
import { FieldAppShell } from "../features/field-app";
import AuthProtected from "./AuthProtected";

// Suspense Fallback
import RouteSuspenseFallback from "../Components/Common/RouteSuspenseFallback";

//routes
import { authProtectedRoutes, publicRoutes, fieldAppRoutes } from "./allRoutes";

// ── Standalone PUBLIC (unauthenticated) pages ──
// These are NOT wrapped by AuthProtected and NOT wrapped by NonAuthLayout —
// they render their own full-screen chrome. A client opens the emailed
// `/handover/:token` link with no session and no auth token.
const PublicHandoverPage = lazy(
  () => import("../features/scaffold-handover/public/public-handover-page")
);

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* ── Standalone public route: scaffold handover accept/reject ──
            Rendered OUTSIDE AuthProtected (no session required) and OUTSIDE
            NonAuthLayout (its own self-contained page). */}
        <Route
          path="/handover/:token"
          element={
            <Suspense fallback={<RouteSuspenseFallback />}>
              <PublicHandoverPage />
            </Suspense>
          }
        />

        {/* ── Public routes (login, register, etc.) ── */}
        <Route>
          {publicRoutes.map((route: any, idx: any) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <Suspense fallback={<RouteSuspenseFallback />}>
                    <NonAuthLayout>
                      <Component />
                    </NonAuthLayout>
                  </Suspense>
                }
                key={idx}
              />
            );
          })}
        </Route>

        {/* ── Field App routes — FieldAppShell (mobile, no desktop chrome) ── */}
        <Route>
          {fieldAppRoutes.map((route, idx) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <Suspense fallback={<RouteSuspenseFallback />}>
                    <AuthProtected>
                      <FieldAppShell>
                        <Component />
                      </FieldAppShell>
                    </AuthProtected>
                  </Suspense>
                }
                key={`field-${idx}`}
              />
            );
          })}
        </Route>

        {/* ── Desktop auth routes — TopDockLayout / VerticalLayout ── */}
        <Route>
          {authProtectedRoutes.map((route, idx) => {
            // Desktop chrome is always TopDockLayout (the legacy Velzon
            // VerticalLayout was removed 2026-06-19; it was never selected).
            const LayoutComponent = TopDockLayout;
            const Component = route.component;

            return (
              <Route
                path={route.path}
                element={
                  <Suspense fallback={<RouteSuspenseFallback />}>
                    <AuthProtected>
                      <LayoutComponent>
                        <Component />
                      </LayoutComponent>
                    </AuthProtected>
                  </Suspense>
                }
                key={idx}
              />
            );
          })}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
